import blackJackImg from '../assets/jacktop_black_jack.png'
import rouletteImg from '../assets/jacktop_roulette.png'
import pockerImg from '../assets/jacktop_pocker.png'
import baccaratImg from '../assets/jacktop_baccarat.png'
import { isStage } from '../../../../shared/domainUtils'

const CLIENT_ID = isStage ? 28 : 146
const SERVER = isStage
  ? 'https://delightful-pebble-058f0fe03-partner.westeurope.1.azurestaticapps.net/init-game?'
  : 'https://web.jacktop.win/init-game?'

export const jacktopConstants = {
  client_id: CLIENT_ID,
  server: SERVER,
  games: {
    black_jack: {
      id: isStage ? 100101 : 113601,
      img: blackJackImg,
    },
    roulette: {
      id: isStage ? 100302 : 113702,
      img: rouletteImg,
    },
    poker: {
      id: isStage ? 100403 : 113803,
      img: pockerImg,
    },
    baccarat: {
      id: isStage ? 100604 : 113904,
      img: baccaratImg,
    },
  },
}



// WEBPACK FOOTER //
// ./js/sport-betting/components/games/jacktop/jacktop_constants.js